export const defaultIgnoreErrors = [
  "ResizeObserver loop limit exceeded",
  "ResizeObserver loop completed with undelivered notifications",
  "Non-Error promise rejection captured",
  "Loading chunk",
  "ChunkLoadError",
  "NetworkError when attempting to fetch resource",
  "Failed to fetch",
  "Load failed",
  "cancelled",
];

export const defaultDenyUrls = [/extensions\//i, /^chrome:\/\//i, /^chrome-extension:\/\//i, /^moz-extension:\/\//i];

export function createBeforeSend() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (event: any, hint: any): any => {
    const error = hint.originalException;

    if (error instanceof Error) {
      const message = error.message ?? "";
      if (
        message.includes("Loading chunk") ||
        message.includes("ChunkLoadError") ||
        message.includes("Failed to fetch dynamically imported module")
      ) {
        return null;
      }
    }

    return event;
  };
}
